<template>
	<div>
		<div v-if="product.saleMessage">
			<center class="top0" style="color:red;padding-bottom:0px;">{{ product.saleMessage }} <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ product.salePrice }}</span></center>
		</div>
		<div v-if="product.sale">
			<center class="top0" style="color:red;padding-bottom:0px;">Save <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ product.sale }}</span> Each!</center>
		</div>
		<div class="itembar">
			<div class="itembar-row">
				<div class="itembar-product-image"><img :src="product.image" :class="'cartImg' + product.id"></div>
				<div v-if="max>1 && product.free != 1" class="itembar-product-desc">
				 <h2><var>{{ product.name }} </var></h2>
				 <h4 v-if="product.flavor">Flavor: <var>{{ product.flavor }}</var></h4>
				 <h4 v-if="product.size">Concentration: <var>{{ product.size }}</var></h4>
                                 <div id="plusMinus">
                                  <span class="minus" @click="changeQuantity('-')">-</span> 
                                   <input v-model="quantity" @change="updateQuantity">
                                  <span @click="changeQuantity('+')" class="plus">+</span>
                                 </div>
				</div>
                                <div v-else class="itembar-product-desc" style="padding-top:0px">
                                        <h2><var>{{ product.name }} </var></h2>
                                        <h4 v-if="product.flavor">Flavor: <var>{{ product.flavor }}</var></h4>
                                        <h4 v-if="product.size">Concentration: <var>{{ product.size }}</var></h4>
                                        <div v-if="product.id != 1">
                                         <var>{{ quantity }}</var>
                                        </div>
                                </div>
				<div v-if="!product.free && !product.sale" class="price" :style="{'margin-top': 0}">
                                       <div>
					<span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">
					 {{ formatPrice }}
					</span>
                                        <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft" class="altPrice" v-if="membership == 1 && product.retailPrice!=product.price">              
                                         {{ product.retailPrice }}
                                        </span>
                                       </div>
                                        <div v-if="membership == 1 && product.retailPrice!=product.price" class="itembar-with-membership">
                                         with your membership
                                        </div>
                                        <div v-if="product.autoPrice>.1 && product.autoPrice!=product.price && product.autoship" class="itembar-subcribed">
                                         <i class="fa-solid fa-check"></i> Subscribe & Save {{ subscribeOff }}%  
                                        </div>
                                        <div v-else-if="product.autoPrice>.1 && product.autoPrice!=product.price" class="itembar-subcribe" @click="subscribeItem">
                                         <i class="fa-solid fa-rotate-right"></i> Subscribe & Save {{ subscribeOff }}% 
                                        </div>
				</div>
                                <div v-if="product.free && product.condition_message" class="price" style="margin:0px;">
                                        <var>FREE*</var>
                                </div>
				<div v-if="product.sale" class="price">
						<s><span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft" style="text-decoration:line-through">{{ formatPrice }}</span></s><br>
						<span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ salePrice }}</span>
				</div>
			</div>
			<div v-if="product.allowAutoship" class="slider-parent">
				<div class="slight-margin-right">Autoship</div>
				<checkbox-slider v-model="autoship"></checkbox-slider>
			</div>
			<div notranslate v-if="product.specialPackSubProducts" class="flex-column">
				<p v-for="subProduct in product.specialPackSubProducts"  :key="subProduct.id" class="no-margin-bottom unset-font">
					{{ subProduct.quantity }}
					{{ subProduct.name }}
					<span class="pos-static unset-font" v-if="subProduct.flavor">
						- {{ subProduct.flavor }}
					</span>
					<span class="pos-static unset-font" v-if="subProduct.size">
						({{ subProduct.size }})
					</span>
				</p>
			</div>
                        <div v-if="product.free && product.condition_message" class="flex-column" style="text-align:center">   
                          *{{ product.condition_message }}
                        </div>
		</div>
	</div>
</template>

<style scoped>
	.slider-parent {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
	}
	.slight-margin-right {
		margin-right: 5px;
	}
	.pos-static {
		position:static !important;
	}
	.unset-font {
		font-size: unset !important;
	}
	.cursor-pointer {
		cursor: pointer;
	}
	.no-margin-bottom {
		margin-bottom: 0;
	}
	.flex-row {
		display: flex;
		flex-direction: row;
	}
	.flex-column {
		display: flex;
		flex-direction: column;
	}

	.indented {
		width: 90%;
		align-self: flex-end;
	}

	.tiny-padding {
		padding: 5px;
	}

	.space-between {
		justify-content: space-between;
	}

	.align-items-center {
		align-items: center;
	}
</style>

<script>
	import CheckboxSlider from './CheckboxSlider.vue'
    export default {
		components: {
			CheckboxSlider
		},
        props: {
            product: Object,
            currencySymbolRight: String,
            currencySymbolLeft: String,
            membership: Number
		},
		data: function () {
			return {
				quantity: this.product.quantity,
				max: this.product.max,
				autoship: this.product.allowAutoship && this.product.autoship,
                salePrice: (this.product.price - this.product.sale).toFixed(2)          
			}
		},
		watch: {
			autoship(n) {
				this.autoshipChanged(n)
			},
//			quantity(n) {
//				this.quantityChanged(n)
//			}
		},
		methods: {
			// increaseQuantity: function () {
			// 	this.product.quantity += 1;
			// 	this.$emit('increaseQuantity', this.product);
			// },
			// decreaseQuantity: function () {
			// 	this.product.quantity -= 1;
			// 	this.$emit('decreaseQuantity', this.product);
			// },
			autoshipChanged(autoship) {
				this.product.autoship = autoship
//				this.$emit('changeProduct', this.product)
			},
                        subscribeItem() {
                           console.log('subscribe item ran');
                           this.$emit('subscribe')
                        },
                 
			quantityChanged: function (quantity) {
				this.product.quantity = quantity;
				this.$emit('changeProduct', this.product);
			},
                        changeQuantity (x) {
                           this.quantity = this.quantity *1;
                           if (x == '-' && this.quantity >0) {
                              this.quantity = this.quantity -1;
                           } else if (x == '+') {
                              this.quantity = this.quantity +1;
                           }
                           this.product.quantity = this.quantity
                           this.$emit('changeProduct', this.product);
                        },
                        updateQuantity: function() {
                           console.log("updateQuantity fired ",this.product.id," - ",this.quantity)
                           this.product.quantity = this.quantity
                           this.$emit('changeProduct', this.product);
                        },
                        deleteItem: function () {
                                this.product.quantity = 0;
//                                this.$emit('changeProduct', this.product);
                        }
		},
		computed: {
			calculatedBV: function () {
				if (this.product.product_months > 1) {
					return this.product.bv + this.product.monthly_bv * (this.product.product_months - 1)
				} else {
					return this.product.bv
				}
			},
			formatPrice: function () {
                                let productPrice = this.product.retailPrice
                                if (this.membership >= 1) {
                                   productPrice = this.product.price
                                }
                                if (this.product.autoPrice && this.product.autoship) {
                                   productPrice = this.product.autoPrice
                                }
		                return productPrice;
			},
                        subscribeOff: function () {
                                let subscribeOff = ((this.product.price - this.product.autoPrice) / this.product.price) * 100
                                subscribeOff = Math.floor(subscribeOff)
                                return subscribeOff
                        }
		}
    }

</script>

<style>
</style>
